import { type ProjectScreensAttributes } from './generated/ProjectScreensAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import { camelize } from 'inflected';
import ScreenDefinition from './ScreenDefinition';
import { ScreenableTypeEnum } from '../Enums';
import Query from '../Query';

interface ProjectScreens extends ProjectScreensAttributes {}

@model
class ProjectScreens extends ApplicationModel {
  static screenableTypeKey(screenableType) {
    return `${camelize(screenableType, false)}ScreenDefinition`;
  }

  static defaultScope(screenableTypes = ScreenableTypeEnum.values) {
    return screenableTypes.reduce(
      (scope, screenableType) =>
        scope.merge({
          [this.screenableTypeKey(screenableType)]: ScreenDefinition.select(
            'screenableType'
          ).merge({
            customFieldDefinitions: ['id', 'key', 'name', 'type'],
          }),
        }),
      new Query(ProjectScreens)
    );
  }

  // Start auto-generated
  static typename: 'ProjectScreens' = 'ProjectScreens';
  get typename(): 'ProjectScreens' {
    return 'ProjectScreens';
  }

  static fields = {
    epicScreenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    featureScreenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    goalScreenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    ideaScreenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    initiativeScreenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    releaseScreenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    requirementScreenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
    taskScreenDefinition: attr.belongsTo({
      readable: true,
      typename: 'ScreenDefinition',
    }),
  };
  // End auto-generated

  screenDefinitionForType(screenableType) {
    const key = ProjectScreens.screenableTypeKey(screenableType);
    return this[key];
  }
}

export default ProjectScreens;
